module.exports = __webpack_public_path__ + "static/img/ad3.ca503b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad3.png
// module id = rfW+
// module chunks = 12